/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const WfespPluginConfBaseR = t.interface({
  id_bean: t.string,

  pag_const_string_profile: t.string,

  pag_rpt_xpath_profile: t.string,

  pag_soap_rule_profile: t.string
});

// optional attributes
const WfespPluginConfBaseO = t.partial({});

export const WfespPluginConfBase = t.intersection(
  [WfespPluginConfBaseR, WfespPluginConfBaseO],
  "WfespPluginConfBase"
);

export type WfespPluginConfBase = t.TypeOf<typeof WfespPluginConfBase>;
